<app-dialog-container>

  <ng-container dialog-header>
    <h4>Import Site</h4>
  </ng-container>

  <ng-container dialog-content>
    <p class="mb-4">
      Search for a Sites Builder 2 site slug.  Type at least 3 characters to start searching.
    </p>

    <div class="w-full mb-4">
      <input
        type="text"
        [formControl]="searchControl"
        placeholder="Search site by name..."
        class="input"
        />
    </div>

    @if (searchState$ | async; as searchState) {
      
      @if (searchState.isLoading) {
        <div class="text-center py-8 text-gray-600">
          <p>Searching...</p>
        </div>
      }

      @if (!searchState.isLoading && searchState.query.length >= 3 && searchState.results.length > 0) {
        
        <div class="flex flex-col gap-3 max-h-[400px] overflow-y-auto scrollbar">
         
          @for (result of searchState.results; track result.id) {
            <div class="flex items-center justify-between p-4 border border-gray-200 rounded-md bg-white transition-shadow hover:shadow-md">
              <div class="flex-1 flex flex-col gap-2">
                <h5 class="m-0 text-base font-semibold text-gray-800">{{ result.title }}</h5>
                <span
                  class="inline-block px-3 py-1 rounded-xl text-xs font-medium w-fit"
                  [ngClass]="result.isCompatible ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
                  >
                  {{ result.isCompatible ? 'Ready to Migrate' : 'Migration Denied' }}
                </span>
              </div>
              <app-button
                [custom]="['disabled:cursor-not-allowed', 'disabled:hover:transform-none', 'disabled:bg-gray-300', 'disabled:text-gray-500']"
                [disabled]="!result.isCompatible"
                (click)="onImport(result.id, result.title)"
                >
                Import
              </app-button>
            </div>
          }
          
        </div>
      }

      @if (!searchState.isLoading && searchState.results.length === 0 && searchState.query.length >= 3) {
        <div class="text-center py-8 text-gray-400 italic">
          <p>No results found</p>
        </div>
      }
    }
  </ng-container>

  <ng-container dialog-actions>
    <app-button data-dialog-close>Close</app-button>
  </ng-container>

</app-dialog-container>
